import {useCallback} from 'react';
import {useLocation} from 'react-router-dom';

import {useUploadedRefundFilesHistoryStore} from '../../components/UploadRefundFiles/store/useUploadedRefundFilesHistoryStore';
import {useUploadedRefundFilesStore} from '../../components/UploadRefundFiles/store/useUploadedRefundFilesStore';
import {useAccordionExpandedStore} from '../../pages/Request/store/useAccordionExpandedStore';
import {useFormChangeDataStore} from '../../pages/Request/store/useFormChangeDataStore';
import {useListRequestFormsStore} from '../../pages/Request/store/useListRequestFormsStore';
import {useSelectedRequestIndexStore} from '../../pages/Request/store/useSelectedRequestIndexStore';
import {useStepStore} from '../../pages/Request/store/useStepStore';
import {useRequestPreviewDataStore} from '../../pages/RequestPreview/store/useRequestPreviewDataStore';
import {useStepPreviewStore} from '../../pages/RequestPreview/store/useStepPreviewStore';
import {useSendAdditionalDocsDataStore} from '../../pages/SendAdditionalDocs/store/useSendAdditionalDocsDataStore';
import {useStepSendDocsStore} from '../../pages/SendAdditionalDocs/store/useStepSendDocsStore';
import {useRefundRequest} from '../useRefundRequest';
import {SHOULD_RESET_PATHS} from './constants';
import {useTreatmentDataStore} from '../../pages/Request/store/useTreatmentDataStore';
import {useTherapiesDataStore} from '../../pages/Request/components/Therapies/store/useTherapiesDataStore';

const shouldReset = (pathname: string) => SHOULD_RESET_PATHS.includes(pathname);

export function useResetRefundFlow() {
	const {pathname} = useLocation();
	const {handleResetStates, resetRequests} = useRefundRequest();

	const condition = shouldReset(pathname);

	const resetStep = useStepStore(state => state.resetStep);
	const resetAccordion = useAccordionExpandedStore(state => state.resetAccordion);
	const resetStepPreview = useStepPreviewStore(state => state.resetStep);
	const resetUploadedFilesHistory = useUploadedRefundFilesHistoryStore(
		state => state.resetUploadedFiles,
	);
	const resetUploads = useUploadedRefundFilesStore(state => state.resetUploadedFiles);
	const resetRequestPreviewData = useRequestPreviewDataStore(state => state.resetData);
	const resetSendAdditionalDocsData = useSendAdditionalDocsDataStore(state => state.resetData);
	const resetStepSendDocs = useStepSendDocsStore(state => state.resetStep);
	const resetFormChangeData = useFormChangeDataStore(state => state.reset);
	const resetSelectedRequestIndex = useSelectedRequestIndexStore(state => state.resetIndex);
	const resetListRequestForms = useListRequestFormsStore(state => state.resetList);
	const resetTreatmentRequest = useTreatmentDataStore(state => state.resetData);
	const resetTherapies = useTherapiesDataStore(state => state.resetTherapies);

	const resetRefundFlow = useCallback(() => {
		if (condition) {
			resetStep();
			resetAccordion();
			resetStepPreview();
			resetUploadedFilesHistory();
			resetUploads();
			resetRequestPreviewData();
			resetSendAdditionalDocsData();
			resetStepSendDocs();
			resetFormChangeData();
			handleResetStates();
			resetRequests();
			resetListRequestForms();
			resetSelectedRequestIndex();
			resetTreatmentRequest();
			resetTherapies();
		}
	}, [condition]);

	const resetRefundFiles = () => {
		resetUploadedFilesHistory();
		resetUploads();
	};

	return {resetRefundFlow, resetRefundFiles};
}
